export default __webpack_public_path__ + "static/sz_en_3-9f6abdf024166b82a004ea09cf803c5b.mp4";